import { Constants } from '@shared/utils/constants';
import { createSearchQueryChangedAction } from '@shared/actions/actions';
export function dispatchSearchQueryChangedAction(dispatch, searchText) {
    return Promise.resolve().then(()=>{
        dispatch(createSearchQueryChangedAction({
            performedQuery: searchText,
            entityType: Constants.EntityType.App
        }));
        dispatch(createSearchQueryChangedAction({
            performedQuery: searchText,
            entityType: Constants.EntityType.Service
        }));
    });
}
const numProductsToTake = 5;
const takeTopN = (entities)=>{
    return entities.slice(0, numProductsToTake).map(({ entityId })=>entityId).join(', ');
};
export const takeTopResults = ({ apps = [], cloudsIndustry = [], services = [] })=>{
    const topApps = takeTopN(apps);
    const topConsultingServices = takeTopN(services);
    const topIndustryClouds = takeTopN(cloudsIndustry);
    return JSON.stringify({
        topApps,
        topConsultingServices,
        topIndustryClouds
    });
};
